import {
  ExtranetCustomerGroupPricingContractDto,
  ExtranetUpdateCustomerGroupDto,
} from '@pharmac-extranet/extranet-api'
import { PharmacContainer, PharmacSelect } from '@pharmac/ui'
import { useEffect, useState } from 'react'
import { UseFormReturn } from 'react-hook-form'

type PricingContractInputProps = {
  formHook: UseFormReturn<ExtranetUpdateCustomerGroupDto>
  availablePricingContracts: ExtranetCustomerGroupPricingContractDto[]
}

type PricingContractItem = ExtranetCustomerGroupPricingContractDto & {
  id: string
}

export const PricingContractInput = ({
  formHook,
  availablePricingContracts,
}: PricingContractInputProps) => {
  const [contracts, setContracts] = useState<PricingContractItem[]>([])
  const [selectedContractId, setSelectedContractId] = useState<string>('')

  const pricingContractId = formHook.watch('pricingContractId')
  const pricingProductId = formHook.watch('pricingProductId')

  useEffect(() => {
    setContracts(availablePricingContracts.map((c) => ({ id: crypto.randomUUID(), ...c })))
  }, [availablePricingContracts])

  useEffect(() => {
    const contract = contracts.find(
      (a) => a.pricingProductId === pricingProductId && a.contractId === pricingContractId
    )

    console.log('PricingContractInput :: DEBUG :: pricingContractId/pricingProductId changed :: ', {
      contract,
      availablePricingContracts,
      pricingProductId,
      pricingContractId,
    })

    if (selectedContractId !== contract?.id) {
      setSelectedContractId(contract?.id ?? '')
    }
  }, [contracts, pricingContractId, pricingProductId])

  const handleOnChange = (id: string) => {
    setSelectedContractId(id)
    if (!id) {
      formHook.setValue('pricingContractId', null as unknown as number, { shouldDirty: true })
      formHook.setValue('pricingProductId', null as unknown as number, { shouldDirty: true })
    }

    if (id) {
      const contract = contracts.find((a) => a.id === id)

      if (!contract) return null

      formHook.setValue('pricingContractId', contract.contractId, { shouldDirty: true })
      formHook.setValue('pricingProductId', contract.pricingProductId, { shouldDirty: true })
    }
  }

  return (
    <PharmacContainer
      marginSmallVertical
      paddingMediumRight
      style={{ width: '100%' }}
    >
      <PharmacSelect
        value={selectedContractId}
        onChange={handleOnChange}
      >
        <option value="">-</option>
        {contracts?.map((contract) => (
          <option
            key={contract.id}
            value={contract.id}
          >
            {contract.productName}
          </option>
        ))}
      </PharmacSelect>
    </PharmacContainer>
  )
}
